export default __webpack_public_path__ + "static/media/snowflake.880e9846.svg";